export default __webpack_public_path__ + "static/location-weather-chart-kohSamui-f802cc253a102dd8c003caa99b0c04da.svg";